import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Intercept password recovery tokens before Supabase strips the hash.
// Supabase redirects recovery to /#access_token=...&type=recovery on the root URL.
// We redirect to /reset-password preserving the hash so the reset page can handle it.
if (window.location.hash.includes('type=recovery') && window.location.pathname !== '/reset-password') {
  window.location.replace('/reset-password' + window.location.hash);
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();